import { Circle } from "@mui/icons-material";
import { Box, Chip, LinearProgress, Link, Stack, Typography } from "@mui/material";
import React from "react";
import pkge from "../../../package.json";
import { isStaging } from "../../api/urls";
import { useAuth } from "../../context/AuthContext";
import BoxContent from "./BoxContent";
import LogoHeader from "./LogoHeader";

function Container({ children }) {
  const { loading } = useAuth();

  return (
    <>
      {isStaging && (
        <Box
          sx={{
            width: "100%",
            bgcolor: "#E8711B",
            py: 0.5,
            textAlign: "center",
            position: "fixed",
            top: 0,
            zIndex: 1300,
          }}
        >
          <Typography
            variant="caption"
            fontWeight={700}
            color="#fff"
            letterSpacing={1}
          >
            AMBIENTE DE HOMOLOGAÇÃO
          </Typography>
        </Box>
      )}
      <Box width={"100%"} maxWidth={460} sx={{ mt: isStaging ? "28px" : 0 }}>
        <BoxContent>
          <LinearProgress
            sx={{ visibility: loading ? "visible" : "hidden" }}
            color="primary"
          />
          <LogoHeader />
          {children}
        </BoxContent>
      </Box>
      <Box
        width={"100%"}
        maxWidth={700}
        pb={1}
        sx={{
          position: { xs: "fixed", sm: "relative" },
          bottom: 0,
          bgcolor: { xs: "#FFF", sm: "transparent" },
        }}
      >
        <Stack
          justifyContent={"center"}
          mt={2}
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          gap={1.5}
        >
          <Typography color="textSecondary" variant="caption">
            Versão {pkge.version}
          </Typography>
          {/* <Circle sx={{ fontSize: ".3rem" }} color="disabled" />
          <Typography
            color="textSecondary"
            component={Link}
            href="https://www.notepay.com/legal/privacy"
            target="_blank"
            variant="caption"
          >
            Política de privacidade
          </Typography>
          <Circle sx={{ fontSize: ".3rem" }} color="disabled" />
          <Typography
            color="textSecondary"
            component={Link}
            href="https://www.notepay.com/legal/terms"
            target="_blank"
            variant="caption"
          >
            Termos de uso
          </Typography> */}
          <Circle sx={{ fontSize: ".3rem" }} color="disabled" />
          <Typography color="textSecondary" variant="caption">
            Powered by{" "}
            <Typography
              component={Link}
              color="textSecondary"
              href="https://www.notepay.com"
              target="_blank"
              variant="inherit"
            >
              NotePay
            </Typography>
          </Typography>
        </Stack>
      </Box>
    </>
  );
}

export default Container;
